const offerDefaultValues = {
	EXPIRES_IN_DAYS: 8,
	EXPIRES_IN_MIN_DAYS: 1,
};

export default offerDefaultValues;
